import { Directive, HostListener, TemplateRef, ViewContainerRef } from '@angular/core';

const DESKTOP_MIN_WIDTH_PX = 992;

abstract class ViewportDirective {
  private hasView = false;
  private resizeTimeout: any = null;

  protected constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) { }

  init() {
    this.updateView();
  }

  destroy() {
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
  }

  resize() {
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }

    this.resizeTimeout = setTimeout(() => {
      this.updateView();
    }, 100);
  }

  protected abstract shouldShow(width: number): boolean;

  private updateView() {
    const width = window.innerWidth;
    const shouldShow = this.shouldShow(width);

    if (shouldShow && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
      return;
    }

    if (!shouldShow && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}

@Directive({
  selector: '[mobile]'
})
export class MobileDirective extends ViewportDirective {
  constructor(templateRef: TemplateRef<any>, viewContainer: ViewContainerRef) {
    super(templateRef, viewContainer);
  }

  ngOnInit() {
    this.init();
  }

  ngOnDestroy() {
    this.destroy();
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.resize();
  }

  protected shouldShow(width: number): boolean {
    return width < DESKTOP_MIN_WIDTH_PX;
  }
}

@Directive({
  selector: '[desktop]'
})
export class DesktopDirective extends ViewportDirective {
  constructor(templateRef: TemplateRef<any>, viewContainer: ViewContainerRef) {
    super(templateRef, viewContainer);
  }

  ngOnInit() {
    this.init();
  }

  ngOnDestroy() {
    this.destroy();
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.resize();
  }

  protected shouldShow(width: number): boolean {
    return width >= DESKTOP_MIN_WIDTH_PX;
  }
}
